import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
} from '@mui/material';
import { useState } from 'react';

import { useInviteUser } from '@/hooks/useInviteUser';
import { useUser } from '@/hooks/useUser';
import { notificationService } from '@/services/notification.service';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

const InviteUserModal = ({ isOpen, onClose, onSuccess }: Props) => {
	const [email, setEmail] = useState('');
	const [name, setName] = useState('');

	const { user } = useUser();

	const { mutate: inviteUser, isPending } = useInviteUser();

	const handleInvite = () => {
		if (!user?.username) {
			notificationService.error('Admin email not available');
			return;
		}

		inviteUser(
			{
				invitedEmail: email,
				adminEmail: user.username,
				name,
			},
			{
				onSuccess: () => {
					notificationService.success('User invited successfully');
					onSuccess();
					onClose();
				},
				onError: (err: any) => {
					notificationService.error(err.message || 'Failed to invite user');
				},
			},
		);
	};

	return (
		<Dialog open={isOpen} onClose={onClose} maxWidth="sm">
			<DialogTitle>Invite a New User</DialogTitle>
			<DialogContent>
				<TextField
					label="Enter name"
					fullWidth
					margin="normal"
					variant="outlined"
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>
				<TextField
					label="Enter email"
					fullWidth
					margin="normal"
					variant="outlined"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button
					variant="contained"
					style={{ backgroundColor: '#00AA55', color: '#fff' }}
					onClick={handleInvite}
					disabled={isPending || !email || !name}
				>
					{isPending ? 'Inviting...' : 'Send Invite'}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default InviteUserModal;
